(function () {
    'use strict';

    angular
        .module('ib-ancillaries-baggages-module')
        .controller('AncillariesBaggagesController', AncillariesBaggagesController);

    AncillariesBaggagesController.$inject = ['$window', '$rootScope', 'MenusConstants', '$scope', 'localStorageService', 'DatalayerUtilsService', 'DatalayerMenusService'];
    function AncillariesBaggagesController ($window, $rootScope, MenusConstants, $scope, localStorageService, DatalayerUtilsService, DatalayerMenusService) {
        const vm = this;
        vm.deleteBaggage = deleteBaggage;

        /**
         * Delete baggages on service  and emit event to delete baggages on ancillaries page
         * @param {String} segment Segment information
         * @param {String} baggageTypeSelected Baggage type to delete
         */
        function deleteBaggage (segment, baggageTypeSelected) {
            let actualPage = '/' + localStorageService.get('actualStepFlow'), segmentsBaggages, trips, trip;
            vm.basketFunctions.isLoading();
            DatalayerMenusService.deleteBaggages(segment, baggageTypeSelected);
            //$scope.$emit('deleteFees');
            if (actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.BOOKING || actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.CHECKIN || actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.MMB) {
                deleteSegmentBaggageSuccess();
                $rootScope.$broadcast('deleteBaggages', segment.segmentId, baggageTypeSelected);
                vm.basketFunctions.calculateAllBasket(actualPage);
                vm.basketFunctions.saveHeaderModel();
                vm.basketFunctions.isNotLoading();
            } else {
                trips = { type: 'BAGGAGE', slices: [] }, trip = { id: segment.segmentId, passengers: [] };

                angular.forEach(segment.baggages, (baggage) => {
                    if (baggage.type === baggageTypeSelected) {
                        angular.forEach(baggage.passengers, (pas) => {
                            trip.passengers.push({ id: pas, subtypes: [baggage.type] });
                        });
                        trips.slices.push(trip);
                    }
                });


                vm.basketFunctions.deleteAncillariesService.deleteAncillarie([trips]).then(() => {
                    deleteSegmentBaggageSuccess();
                    $rootScope.$broadcast('deleteBaggages', segment.segmentId, baggageTypeSelected);
                    vm.basketFunctions.calculateAllBasket(actualPage);
                    vm.basketFunctions.saveHeaderModel();
                    vm.basketFunctions.isNotLoading();
                    DatalayerUtilsService.setAncillariesDatalayer();
                    $rootScope.$broadcast('basketUpdateCommonHeader');
                }, (error) => {
                    vm.basketFunctions.isNotLoading();
                    vm.basketFunctions.modalService.setErrorMessage(error.message);
                    vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                    vm.basketFunctions.modalService.isError(error);
                    vm.basketFunctions.collapseHeader.closeCollapse();
                });
            }

            function deleteSegmentBaggageSuccess () {

                let i, j, baggageSelected;
                for (i = 0; i < vm.model.segments.length; i++) {
                    if (vm.model.segments[i].segmentId === segment.segmentId) {
                        for (j = 0; j < vm.model.segments[i].baggages.length; j++) {
                            if (vm.model.segments[i].baggages[j].type === baggageTypeSelected) {
                                segment.total -= vm.model.segments[i].baggages[j].total;
                                baggageSelected = j;
                            }
                        }
                        vm.model.segments[i].baggages.splice(baggageSelected, 1);
                    }
                }
                segmentsBaggages = vm.model.segments.filter((segment) => {
                    return (segment.total > 0);
                });
                vm.model.segments = segmentsBaggages;

                if (vm.model.segments.length === 0) {
                    vm.model.hasBaggage = false;
                }
                const ancInfo = localStorageService.get('ancillariesInfo');
                if(ancInfo.bundles) {
                    let passengersNum = 1;
                    let maxBaggs = 9;
                    for(let i = 0; i < ancInfo.ancillaries.length; i++) {
                        if(ancInfo.ancillaries[i].type === 'BAGGAGE') {
                            passengersNum = ancInfo.ancillaries[i].slices[0].passengers.length;
                            maxBaggs = ancInfo.ancillaries[i].slices[0].passengers[0].maxAdditionalPieces;
                        }
                    }
                    let maxBaggsPerSegment = maxBaggs * passengersNum;
                    let messageHasToBeShown = false;
                    for (let i = 0; i < vm.model.segments.length; i++) {
                        let baggsInSegment = 0;
                        for(let j = 0; j < vm.model.segments[i].baggages.length; j++) {
                            baggsInSegment += vm.model.segments[i].baggages[j].quanty;
                        }
                        if(baggsInSegment === maxBaggsPerSegment) {
                            messageHasToBeShown = true;
                        }
                    }
                    if(messageHasToBeShown) {
                        localStorageService.set('bundleHaveBaggs', true);
                    } else {
                        localStorageService.set('bundleHaveBaggs', false);
                    }
                }
            }
        }
    }
})();